import { Fragment } from "react";

/**
 * Indicator component
 * 
 * @param {object} props
 * @param {Array} props.steps - Array of steps { id, label }
 * @param {number} props.currentStep - Current active step number
 */
export default function Indicator({ steps, currentStep }) {
    return (
        <div className="flex px-9 gap-3 items-center">
            {steps.map((step, index) => (
                <Fragment key={step.id}>
                    <div className="flex items-center justify-center gap-2 shrink-0">
                        <div className={`w-7 h-7 rounded-round p-3 gap-3 flex items-center justify-center font-ui text-body-small text-main-typography-system-inverted ${currentStep >= step.id
                            ? "font-header bg-main-background-system-brand"
                            : "font-body bg-creation-neutral-solid-surface-default"
                            }`}>
                            {step.id}
                        </div>
                        <span className={`font-ui text-body-small whitespace-nowrap ${currentStep >= step.id
                            ? "font-header text-main-typography-system-default"
                            : "font-body text-main-typography-system-description"
                            }`}>
                            {step.label}
                        </span>
                    </div>

                    {index < steps.length - 1 && (
                        <div className="flex-1 h-[1px] bg-creation-neutral-solid-surface-default">
                            <div className={`h-full transition-all duration-700 ease-in-out ${currentStep > step.id ? "bg-creation-primary-solid-surface-default w-full" : "w-0"
                                }`}></div>
                        </div>
                    )}
                </Fragment>
            ))}
        </div>
    );
}
